import React, { useEffect, useState } from "react";
import SpeakerModal from "./SpeakerModal";
import "../../styles/SpeakerPage.scss";
import { Speaker } from "../../types/speaker";

interface SpeakerJson {
  speakers: Speaker[];
}

export default function SpeakerPage() {
  const [speakers, setSpeakers] = useState<Speaker[]>([]);
  const [selectedSpeaker, setSelectedSpeaker] = useState<Speaker | null>(null);

  useEffect(() => {
    fetch("/resources/speaker.json")
      .then((res) => res.json())
      .then((data: SpeakerJson) => setSpeakers(data.speakers || []))
      .catch(console.error);
  }, []);

  if (speakers.length === 0) return null;

  return (
    <div className="speaker-wrapper">
      <header className="speaker-header">
        <div className="s-header-bg" />
        <div className="s-header-content">
          <h1 className="speaker-page-title s-cutout-text" data-text="Speakers">
            Speakers
          </h1>
          <h2
            className="speaker-page-title s-cutout-text sub"
            data-text="APLIC 2027"
          >
            APLIC 2027
          </h2>
        </div>
      </header>

      <section className="speaker-page-section">
        <div className="speaker-page-container">
          <div className="speaker-top-layout">
            <div className="speaker-intro">
              <h2 className="speaker-title">
                Visionaries. Trailblazers. Industry Game-Changers.
              </h2>
              <p className="speaker-paragraph">
                APLIC 2027 brings together a powerhouse lineup of leaders shaping
                the future of business, creativity, performance, and financial
                services across the Asia-Pacific region.
              </p>
            </div>

            <div
              className="featured-speaker"
              onClick={() => setSelectedSpeaker(speakers[0])}
            >
              <img src={speakers[0].image} alt={speakers[0].name} />
              <div className="speaker-overlay">
                <span className="speaker-overlay-name">
                  {speakers[0].name}
                </span>
              </div>
            </div>
          </div>

          <div className="speaker-grid">
            {speakers.slice(1).map((sp) => (
              <div
                key={sp.id}
                className="speaker-card"
                onClick={() => setSelectedSpeaker(sp)}
              >
                <img src={sp.image} alt={sp.name} />
                <div className="speaker-overlay">
                  <span className="speaker-overlay-name">{sp.name}</span>
                </div>
              </div>
            ))}
          </div>

          {selectedSpeaker && (
            <SpeakerModal
              speaker={selectedSpeaker}
              onClose={() => setSelectedSpeaker(null)}
            />
          )}
        </div>
      </section>
    </div>
  );
}
